import React from "react";
import imgDummie from "./assets/dummie.jpg";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";

export type TGalleryItem = {
  title: string;
  imgUrl?: string;
  links?: string[];
};

export interface IUsersGalleryItem extends TGalleryItem {
  compClass: string;
}

const UsersGalleryItem = (props: IUsersGalleryItem) => {
  const { imgUrl, title, links, compClass } = props;
  // const icons = [FaFacebookF, FaTwitter, FaInstagram, FaLinkedin];
  return (
    <div className={`${compClass}__item`}>
      <div className={`${compClass}__itemImage`}>
        <img src={imgUrl || imgDummie} alt={title} />
      </div>
      <h5 className={`${compClass}__itemTitle`}>{title}</h5>
      {/* {links && links.length > 0 && (
        <div className={`${compClass}__itemLinks`}>
          {icons.map((Icon, index) => (
            <Icon key={index} className={`${compClass}__itemLink`} />
          ))}
          {links?.map((link, index) => (
            <a
              key={index}
              href={link}
              className={`${compClass}__itemLink`}
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default UsersGalleryItem;
